import 'whatwg-fetch';
import { api, jumboQAtransbank, features } from 'config';
import StorageService from 'services/StorageService';
import PubSub from 'services/PubSub';
import Log from 'services/Log';
import LoginService from 'services/Login';
import TagManagerService from "services/TagManager";
import {walletPaymentsName, paymentsName} from "config/index";
import NewRelicService from 'services/NewRelic'
import { consumer, ecommerce } from 'config/constants';

let selectedToken = null;
let statusAttempts = 0;
const timeAttempts = 10000;
const msgAttempts = [
    'Tu pago está siendo procesado, espera un momento.',
    'Aún no hemos terminado, espera un momento.'
];

const selectCard = (card) => {
    if(!card) return false;
    selectedToken = card.token;
}

const _sendPurchase = (tId) => {
    const token = StorageService.getItem('sessionData');

    const payload = {
        "idCard": selectedToken,
        "tId": tId
    };
    let headers = {
        'x-api-key': api.apiKey,
        'token': token,
        'pragma': 'no-cache',
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    }

    if(ecommerce.whiteLabel || ecommerce.JumboTest){
        headers['x-consumer'] = consumer;
    }

    return fetch(api.wallet + `/wallet/transaction`, {
        method: 'POST',
        headers,
        body: JSON.stringify(payload),
    }).then(data => data.json())
        .catch(err => {
            Log.captureException(err);
            return false
        });
}

const purchase = (tId = null) => {
    return _sendPurchase(tId).then(data => {
        if(data && data.internalCode === '200-2'){
            statusAttempts = 0;
            return _getPaymentStatus(tId);
        }

        NewRelicService.sendPageAction({
            action: 'walletPayment',
            payload: {
                status: 'success',
                tId,
                internalCode: data ? data.internalCode : null
            }
        });

        return data;
    });
}

const __getPaymentStatus = (tid) => {
    if(!tid){
        return Promise.reject(false);
    }
    let headers = {
        'x-api-key': api.apiKey,
        'token': token,
        'pragma': 'no-cache',
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    }
    
    if(ecommerce.whiteLabel || ecommerce.JumboTest){
        headers['x-consumer'] = consumer;
    }

    const token = StorageService.getItem('sessionData');

    return fetch(api.wallet + `/wallet/status/${tid}`, {
        headers
    }).then(data => data.json());
}

const _getPaymentStatus = (tid) => {
    NewRelicService.sendPageAction({
        action: 'walletPayment',
        payload: {
            status: 'inProgress',
            tId: tid
        }
    });
    _sendNotification(msgAttempts[statusAttempts]);
    return new Promise(resolve => {
        setTimeout(()=> {
            __getPaymentStatus(tid).then(data => {
                if(data && data.internalCode === '200-2'){
                    statusAttempts++;
                    resolve(_getPaymentStatus(tid));
                    return false;
                }
                NewRelicService.sendPageAction({
                    action: 'walletPayment',
                    payload: {
                        status: 'success',
                        tId: tid
                    }
                });
                resolve(data);
            });
        },timeAttempts);
    });
}

const _sendNotification = (msg) => {
    if(!msg) return false;
    setTimeout(() => {
        PubSub.dispatch('open_snackbar',{
            TitleMobile: msg,
            TitleDesktop: msg,
            timer: 15000,
            type: 'wallet'
        });
    },0);
}
let cachePromise = null;

const getWalletCards = () => {
    let _cardsList = [];
    if(cachePromise) return cachePromise;
    const token = LoginService.getUserToken();
    const headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'token': token,
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    }
    
    if(ecommerce.whiteLabel || ecommerce.JumboTest){
        headers['x-consumer'] = consumer;
    }

    if (jumboQAtransbank) {
        Object.assign(headers, {'x-consumer': 'jumboQA'})
    }

    cachePromise = fetch(api.wallet + `/wallet/cards`, {
        method: 'GET',
        headers
    }).then(data => data.json())
        .then((data)=> {
            if(data && data.results && data.results.length){
                StorageService.updateValidationStorage('is-wallet', 'cards');
                let creditCards = data.results.filter(results => results.paymentMethod === walletPaymentsName.oneClick || results.paymentMethod === walletPaymentsName.catOneClick )
     
                if(!creditCards.length){
                    PubSub.dispatch('gtm_debit_card', walletPaymentsName.debitOneClick);
                }
                
            }else{
                StorageService.updateValidationStorage('is-wallet', 'not-cards');
                PubSub.dispatch('gtm_not_card');
            }
            cachePromise = null;

            _cardsList = _orderCards(data.results);
            data.results = _cardsList; 

            return data
        });
    return cachePromise
}

const _orderCards = (_data)=> {

    let cencoCat = [];
    let creditCards = [];
    let debitCards =[];
    let prepaidCards = [];
    let orderedList = [];

    _data.map((item) => {
        if (item.paymentMethod === walletPaymentsName.catOneClick) {
            cencoCat.push(item);
        }
        if (item.paymentMethod === walletPaymentsName.oneClick) {
            creditCards.push(item);
        }
        if (item.paymentMethod === walletPaymentsName.debitOneClick) {
            if (item.brand === "RedCompra") {
                debitCards.push(item);
            }
            if (features.prepaid && item.brand === "Prepago") {
                prepaidCards.push(item);
            }  
        } 
    })

    orderedList = orderedList.concat(cencoCat, creditCards, debitCards, prepaidCards);

    return orderedList
}

const deleteWalletCard = (cardToken) => {
    const token = LoginService.getUserToken();
    const headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'token': token,
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    }
    if(ecommerce.whiteLabel || ecommerce.JumboTest){
        headers['x-consumer'] = consumer;
    }

    if (jumboQAtransbank) {
        Object.assign(headers, {'x-consumer': 'jumboQA'})
    }

    return fetch(api.walletV2 + `/wallet/card/${cardToken}`, {
        method: 'DELETE',
        headers
    }).then(data => data.json())
        .then(results => {
            if (results.status === 401) {
                setTimeout(() => {
                    PubSub.dispatch('open_snackbar', {
                        TitleMobile: 'Puedes eliminar tu tarjeta una vez que tu pedido haya sido recolectado y la boleta haya sido emitida.',
                        TitleDesktop: `Puedes eliminar tu tarjeta una vez que tu pedido haya sido recolectado y la boleta haya sido emitida.`,
                        timer: 15000,
                        titleButtonMobile: 'Cerrar',
                        titleButtonDesktop: 'Cerrar',
                        type: 'cardListError',
                        callback: () => {}
                    });
                }, 0);
            }
            let _cardsList = [];
            _cardsList = _orderCards(results.results);
            results.results = _cardsList;
            return results
        });
}

const isFavoriteWalletCard = (cardToken) => {
    const token = LoginService.getUserToken();
    const headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'token': token,
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    }
    if(ecommerce.whiteLabel || ecommerce.JumboTest){
        headers['x-consumer'] = consumer;
    }
    
    if (jumboQAtransbank) {
        Object.assign(headers, {'x-consumer': 'jumboQA'})
    }

    return fetch(api.wallet + `/wallet/card/${cardToken}`, {
        method: 'PUT',
        headers
    }).then(data => data.json())
        .then((data)=> {
            let _cardsList = [];
            _cardsList = _orderCards(data.results);
            data.results = _cardsList; 
            return data
        });
}

const addWalletCard = (paymentMethod, bin = false) => {
    const token = LoginService.getUserToken();
    const userData = StorageService.getSecureItem('userData');
    const callback = window.location.href || null;
    let payload = {
        'email': userData.email,
        'firstName': userData.firstName,
        'lastName': userData.lastName,
        'callback': callback
    }
    if(bin){
        payload.bin = bin;
    }
    const headers = {
        'x-api-key': api.apiKey,
        'pragma': 'no-cache',
        'token': token,
        'cache-control': 'no-cache',
        'Content-Type': 'application/json'
    }
    if(ecommerce.whiteLabel || ecommerce.JumboTest){
        headers['x-consumer'] = consumer;
    }

    if (jumboQAtransbank) {
        Object.assign(headers, {'x-consumer': 'jumboQA'})
    }
    return fetch(api.wallet + `/wallet/card/${paymentMethod}`, {
        method: 'POST',
        headers,
        body: JSON.stringify(payload)
    }).then(data => data.json());
}

const sendGtm = (methodId) => {
    if (methodId === walletPaymentsName.oneClick) {
        const actionField = {
            'step': 4,
            'option': paymentsName.oneClick
        };

        TagManagerService.onCheckoutOption(actionField);
    } else {
        const actionField = {
            'step': 4,
            'option': paymentsName.catOneClick
        };
        TagManagerService.onCheckoutOption(actionField);
    }
}

const getInitCards = () => {
    const isWallet = StorageService.getValidationStorage('is-wallet', false)
    const userData = StorageService.getSecureItem('userData');

    if(isWallet === 'cards'){
        return Promise.resolve(true);
    }
    if(isWallet === 'not-cards' || !userData) {
        return Promise.resolve(false)
    }
    if(userData){
        return getWalletCards().then((response)=> {
            if(response && response.results && response.results.length){
                return true;
            }else{
                return false;
            }
        })
    }
}

const sendStepGtm = (cardsList) => {
    let cardPayment = StorageService.getItem('card-payment');
    if(cardsList?.length && cardPayment){
        
        cardPayment = cardPayment && JSON.parse(cardPayment);
        let newCard = cardsList?.filter((card) => {
            if(cardPayment?.listCards?.length){
                let currentCard = cardPayment?.listCards?.filter((oldCard) => oldCard.token === card.token);

                if(!currentCard?.length) {
                    return true
                }
    
                return false;
            }
            
        })

        if(((newCard && newCard[0]?.brand) || newCard?.brand)  === 'Prepago') {
            TagManagerService.interaction('Step 3: Medio de pago guardado con éxito', 'Tarjeta prepago', 'Agregar nuevo medio de pago')
            
        } else if(((newCard && newCard[0]?.paymentMethod) || newCard?.paymentMethod) === 'DebitoOneClick' && (newCard && newCard[0]?.brand ) !== 'Prepago') {
            cardPayment.type = 'Tarjeta de débito'
            TagManagerService.interaction('Step 3: Medio de pago guardado con éxito', cardPayment?.type, 'Agregar nuevo medio de pago')

        } else {
            TagManagerService.interaction('Step 3: Medio de pago guardado con éxito', cardPayment?.type, 'Agregar nuevo medio de pago')
        }

        StorageService.removeItem('card-payment');
    }
}

const WalletService = {
    selectCard,
    purchase,
    getWalletCards,
    deleteWalletCard,
    isFavoriteWalletCard,
    addWalletCard,
    sendGtm,
    getInitCards,
    sendStepGtm
}

export default WalletService;
